import React, { useEffect, useState, useMemo } from "react";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";

import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";

import { fetchDropdownValues } from "../../../common_nextgen/common_components/dropdown/DropdownHelper";
import getBackendUrl from "../../../environment/BackendService";

import { Button } from "primereact/button";
import { useLocation } from "react-router-dom";
import { useModal } from "../../../common_nextgen/hooks/ModalContext";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";
import { downloadCSV } from "../../../common_nextgen/utils/UtilFunctions";
import { LegacyResolvers } from "../../../common_nextgen/utils/UtilFunctions";

/**
 *
 * @param {{ps3PatientPaySchName: string, ps3PatientPaySchDesc: string, hiddenRecordIndicator: "Active" | "A" | "H"}[]} SelectedSchedules
 * @param {number} initialIndex
 * @returns
 */
function getParamsData(selectedPatients, initialIndex) {
  return {
    patientPaySchedule: selectedPatients[initialIndex]?.ps3PatientPaySchName,
    description: selectedPatients[initialIndex]?.ps3PatientPaySchDesc,
    hiddenRecordIndicator: "A",
  };
}

const useClientPatientPaySchedule = () => {
  const { axios_helper_no_header } = useAxios();
  const [data, setData] = useState([]); /* Client Patient Pay Schedule Data */
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const toast = useToast();
  const location = useLocation();
  const { showModal } = useModal();
  const [isInactiveConfirmationModalOpen, setIsInactiveConfirmationModalOpen] =
    useState(false);
  const [inactiveSelectedOption, setInactiveSelectedOption] = useState("no");

  /*const stateVal = location.state;
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);*/

  const [stateVal, setStateVal] = useState(location.state || []);
  const { currentState, previousState } = useMemo(() => {
    let [currentState = {}] = [...stateVal].reverse();
    const previousState = [...stateVal];
    previousState.splice(stateVal.length - 1, 1);
    return {
      previousState,
      currentState,
    };
  }, [stateVal]);

  const {
    selectedPatients = [],
    previousScreen = ROUTE_PATHS.PATIENT_PAY_SCHEDULE,
    currentIndex: initialIndex = 0,
    externalMode: initialExternalMode = false,
  } = useMemo(() => {
    const { selectedPatients, previousScreen, currentIndex, externalMode } =
      currentState;
    return {
      selectedPatients,
      previousScreen,
      currentIndex,
      externalMode,
    };
  }, [currentState]);

  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [externalMode, setExternalMode] = useState(initialExternalMode);
  const [paramsData, setParamsData] = useState(
    getParamsData(selectedPatients, initialIndex)
  );

  const {
    ADD_CLIENT_PATIENT_PAY_SCHEDULE,
    EDIT_CLIENT_PATIENT_PAY_SCHEDULE,
    DISPLAY_CLIENT_PATIENT_PAY_SCHEDULE,
    PATIENT_PAY_SCHEDULE,
  } = ROUTE_PATHS;

  const screen_title = "Client Patient Pay Schedule";
  const screenNumber = "RCPS6001";

  /* Search form fields that needs to be shown for filtering */
  const formFields = [
    {
      fieldLabel: "Patient Pay Schedule",
      name: "patientPaySchedule",
      label: "Patient Pay Schedule",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 10,
    },
    {
      fieldLabel: "Description",
      name: "description",
      label: "Description",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 25,
    },
    {
      fieldLabel: "Hidden Records Indicator*Inactive",
      name: "hiddenRecordIndicator",
      label: "Status",
      type: "dropdown",
      fieldNature: "editable",
      value: "",
      maxLength: 1,
    },
  ];

  /* Top Left Back button info that needs to be displayed on the page*/
  const leftButtons = [
    {
      button_label: "Back",
      button_handeler: () => {
        if (externalMode) {
          const message = {
            message: "navigate-to-external-program",
            url: previousScreen,
            parameters: {
              state: [...previousState],
            },
          };
          console.log("back messages", message);
          window.parent.postMessage(message, "*");
        } else if (currentIndex < selectedPatients.length - 1) {
          setCurrentIndex(currentIndex + 1);
        } else {
          navigateToPage(previousScreen, previousState);
        }
      },
      button_key: "F12",
    },
  ];

  /* Dropdown options fields that needs to be fetched with API */
  const dropdownOptions = [
    { fieldLabel: "Hidden Records Indicator*", condition: "Inactive" },
  ];

  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.fieldLabel + item.condition),
  };

  /* ACTION BUTTONS info that needs to be displayed on the page */
  const ctaButtons = [
    {
      button_label: "Add Client Patient Pay Schedule",
      button_handeler: () => {
        navigateToPage(ADD_CLIENT_PATIENT_PAY_SCHEDULE, [
          ...previousState,
          { ...currentState, currentIndex, externalMode },
          {
            previousScreen: location.pathname,
            paramsData,
            selectedPatients,
          },
        ]);
      },
      button_key: "F6",
    },
    {
      button_label: "Export as CSV",
      button_handeler: () => {
        exportAsCSV();
      },
      button_key: "",
    },
  ];

  /* Gear Icon Menu option CTAs */

  const menuOptions = [
    {
      label: "Edit",
      icon: <span className="material-icons">edit</span>,
      command: () => {
        navigateToPage(EDIT_CLIENT_PATIENT_PAY_SCHEDULE, [
          ...previousState,
          { ...currentState, currentIndex, externalMode },
          {
            selectedSchedules: selectedRows.length ? selectedRows : [rowData],
            previousScreen: location.pathname,
            paramsData,
          },
        ]);
      },
    },
    {
      label: "Inactivate",
      icon: <span className="material-icons">block</span>,
      command: () => {
        openInactiveConfirmationModal();
      },
    },
    {
      label: "Display",
      icon: <span className="material-icons">visibility</span>,
      command: () => {
        navigateToPage(DISPLAY_CLIENT_PATIENT_PAY_SCHEDULE, [
          ...previousState,
          { ...currentState, currentIndex, externalMode },
          {
            selectedSchedules: selectedRows.length ? selectedRows : [rowData],
            previousScreen: location.pathname,
            paramsData,
          },
        ]);
      },
    },
  ];

  const viewPatientPayScheduleDetails = (rowData) => {
    console.log(rowData, "schedule");
    /* const message = {
      message: "navigate-to-presto",
      programCode: "RCPS3014",
      parameters: {
        ps3PatientPaySchName: rowData.ps6RebillPatPaySched,
        ps3PatientPaySchDesc: rowData.ps6Description,
      },
    };
    console.log(message, "message");
    window.top?.postMessage(message, "*");
    */
    const viewParams = [
      {
        source: "ps6RebillPatPaySched",
        target: "ps3PatientPaySchName",
        paramDataKey: "scheduleName",
        legacy: "ps3PatientPaySchName",
      },
      {
        source: "ps6Description",
        target: "ps3PatientPaySchDesc",
        legacy: "ps3PatientPaySchDesc",
      },
    ];
    const paramData = viewParams.reduce((acc, item) => {
      const resolver = item["resolver"]
        ? LegacyResolvers[item["resolver"]]
        : null;
      acc[item["target"]] = resolver
        ? resolver(rowData[item["source"]])
        : rowData[item["source"]];
      return acc;
    }, {});

    navigateToPage(ROUTE_PATHS.PATIENT_PAY_SCHEDULE_DISPLAY, [
      ...previousState,
      { ...currentState, currentIndex, externalMode },
      {
        selectedPatients: [rowData],
        currentIndex: 0,
        paramsData: { ...paramData, cscStepNbr: null },
        previousScreen: location.pathname,
      },
    ]);
  };

  /* Data table column info. */
  const columnDef = [
    {
      header: "From Date",
      field: "ps6FromDate",
    },
    {
      header: "Thru Date",
      field: "ps6ThruDate",
    },
    {
      header: "Client Patient Pay Schedule",
      field: "ps6RebillPatPaySched",
      body: (rowData) => {
        return (
          <Button
            label={rowData.ps6RebillPatPaySched}
            link
            onClick={(e) => {
              viewPatientPayScheduleDetails(rowData);
            }}
          />
        );
      },
    },
    {
      header: "Client Patient Pay Description",
      field: "ps6Description",
    },
    {
      header: "Status",
      field: "ps6Status",
    },
  ];

  /* Param Key which used as bridge between various operations on tabluar data */
  const parmKey = "recordId";

  /* Handler that fetches the data */
  const fetchData = async () => {
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/ps6RebillPatientPaySch`,
        null,
        {
          page: page,
          size: rows,
          ...paramsData,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        setTotalRecords(pageResponse.totalRecords); // Assuming the API returns totalRecords
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };
  useEffect(() => {
    fetchDropdownData(dropdownCondition);
  }, []);
  useEffect(() => {
    if (currentIndex !== initialIndex)
      setParamsData(getParamsData(selectedPatients, currentIndex));
  }, [currentIndex, initialIndex]);
  useEffect(() => {
    setParamsData(getParamsData(selectedPatients, currentIndex));
  }, [externalMode]);

  useEffect(() => {
    paramsData.patientPaySchedule && fetchData(); // Initial fetch with page 0 and page size 10
  }, [paramsData, rows, currentPage]);

  const onPageChange = (event) => {
    console.log("page change", event.first, event);
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    console.log(selectedOption);
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const openInactiveConfirmationModal = () => {
    setIsInactiveConfirmationModalOpen(true);
  };

  const closeInactiveConfirmationModal = () => {
    console.log(inactiveSelectedOption);
    setIsInactiveConfirmationModalOpen(false);
    setInactiveSelectedOption("no");
  };

  const exportAsCSV = async () => {
    const queryParams = new URLSearchParams({ ...paramsData });

    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/ps6RebillPatientPaySch/exportCsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const inactivateRecord = () => {
    if (inactiveSelectedOption === "yes") {
      let payload = [
        {
          ps3PatientPaySchName:
            selectedPatients[currentIndex].ps3PatientPaySchName,
          ps6SeqNbr: rowData.ps6SeqNbr,
        },
      ];
      const params = {
        screenNumber,
      };

      if (selectedRows?.length) {
        payload = selectedRows.map((item) => ({
          ps3PatientPaySchName: item.ps3PatientPaySchName,
          ps6SeqNbr: item.ps6SeqNbr,
        }));
      }
      axios_helper_no_header(
        "PUT",
        "api/ps6RebillPatientPaySch/inactivateRecord",
        payload,
        params
      )
        .then((response) => {
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeInactiveConfirmationModal();
        })
        .catch((error) => {
          console.error("There was an error in activating the record!", error);
          const errorMessage =
            error.data?.responseStatus?.message || error.message;
          toast.current.show({
            severity: "error",
            summary: "",
            detail: errorMessage,
            life: 3000,
          });
          closeInactiveConfirmationModal();
        })
        .finally(() => {
          fetchData();
        });
    } else {
      closeInactiveConfirmationModal();
    }
  };
  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  const handleMessage = (event) => {
    const { type, data } = event.data;

    if (type === "set-params") {
      setStateVal(data);
      setExternalMode(true);
    }
    console.log("message", event.data);
  };

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  });

  useEffect(() => {
    setCurrentIndex(initialIndex);
  }, [initialIndex]);
  useEffect(() => {
    setExternalMode(initialExternalMode);
  }, [initialExternalMode]);

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    leftButtons,
    data,
    parmKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    setSelectedOption,
    inactivateRecord,
    isInactiveConfirmationModalOpen,
    closeInactiveConfirmationModal,
    setInactiveSelectedOption,
  };
};

export default useClientPatientPaySchedule;
